// ─────────────────────────────────────────────────────────────
// EDIT THIS FILE to personalise the site.
// Swap the email and Calendly link below when ready.
// ─────────────────────────────────────────────────────────────
export const site = {
  name: "Arnold Alexander",
  initials: "AA",
  role: "SEO & AI Visibility Consultant",
  tagline: "I help businesses get found on Google and recommended by AI tools like ChatGPT. That's the whole job.",
  email: "hello@arnoldalexander.com",
  location: "India · Remote worldwide",
  calendlyUrl: "https://calendly.com/arnoldalex1999/30min",
};
